<template>
  <div class="wy-list-page">

    <floating-button :route="{ name: 'Product' }"/>
    <CCard>
      <CCardBody>

        <CAlert color="danger" v-if="!_.isEmpty(error)" closeButton @update:show="error = ''">
          {{ error }}
        </CAlert>

        <CAlert color="success text-center" v-if="!_.isEmpty(message)">
          {{ message }}
        </CAlert>

        <div v-if="!loaded">
          <inline-loader/>
        </div>

        <div v-if="loaded">
          <div class="wy-search-input-container" v-if="_.isEmpty(message)">
            <input
                class="form-control full-width"
                :placeholder="$t('type_here_to_search')"
                type="text"
                v-model="search"
                @input="runSearch"
                @keydown.esc="clearSearch"
            />
            <button class="wy-clear-button" @click="clearSearch" v-if="search !== ''">
              <span class="wy-icon-clear-input"></span>
            </button>
          </div>

          <CAlert color="success text-center" class="mt-3" v-if="noSearchResult">
            {{ $t('no_result_found') }}
          </CAlert>

          <div v-if="!_.isEmpty(products)">
            <div class="table-responsive-md">
              <table class="table table-hover wy-list-table">
                <thead>
                <tr>
                  <th style="width: 50px;">&nbsp;</th>
                  <th style="width: 50px;">#</th>
                  <th>{{ $t('name') }}</th>
                  <th class="text-center">{{ $t('cost_price') }}</th>
                  <th class="text-center">{{ $t('consumer_price') }}</th>
                  <th class="text-center">{{ $t('price_with_vat') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(product, productIndex) in products"
                    :key="`product_${productIndex}`"
                    :class="{ 'wy-blocked-table-row': product.blocked }">
                  <td :style="{ 'background-color': product.color }">&nbsp;</td>
                  <td>{{ product.id }}</td>
                  <td>
                    <strong>{{ product.name }}</strong>
                    <div class="text-muted" v-if="!_.isEmpty(product.serial_number)">
                      <small>{{ product.serial_number }}</small>
                    </div>
                  </td>
                  <td class="text-center">
                    <div v-if="product.free_price">
                      {{ $t('free_price') }}
                    </div>
                    <div v-else>
                      {{ product.cost_price }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div v-if="product.free_price">
                      {{ $t('free_price') }}
                    </div>
                    <div v-else>
                      {{ product.consumer_price }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div v-if="product.free_price">
                      {{ $t('free_price') }}
                    </div>
                    <div v-else>
                      {{ withVat(product.consumer_price) }}
                    </div>
                  </td>
                  <td style="width: 120px; white-space: nowrap;">
                    <div class="row">
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="toggleBlock(productIndex)" :class="{ 'text-red': product.blocked }"><i class="wy-icon-ban p-0"></i></CButton>
                      </div>
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="editProduct(productIndex)"><i class="wy-icon-pencil p-0"></i></CButton>
                      </div>
                      <div class="col">
                        <CButton color="wy-action-button p-0" @click="deleteProduct(productIndex)"><i class="wy-icon-delete p-0"></i></CButton>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="row wy-pagination-info">
              <div class="col">
                {{ $t('from') }} {{ from }}
                {{ $t('to') }} {{ to }}
              </div>
              <div class="col text-right">
                <strong>{{ $t('total') }}: {{ total }}</strong>
              </div>
            </div>

            <CPagination
                align="center"
                :pages="lastPage"
                :active-page.sync="currentPage"
            />
          </div>
        </div>

      </CCardBody>
    </CCard>

  </div>
</template>

<script>
import { products, deleteProduct, unBlockProduct, blockProduct } from "@/api/product";
import FloatingButton from "../../components/FloatingButton";
import InlineLoader from "../../components/InlineLoader";
import _ from "lodash";

export default {
  name: 'ProductsList',
  components: {
    FloatingButton,
    InlineLoader,
  },
  data() {
    return {
      currentPage: 0,
      activePage: 0,
      firstPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0,
      from: 0,
      to: 0,
      message: '',
      error: '',
      search: '',
      loaded: false,
      noSearchResult: false,
      //
      products: [],
      setting: [],
    };
  },
  watch: {
    currentPage(newValue) {
      this.getProducts();
      this.$router.replace({name: this.$route.name, params: this.$route.params, query: {page: newValue}});
    },
    '$route.query.page': function (page) {
      if (this._.isUndefined(page)) {
        page = 1;
      }
      this.error = '';
      this.currentPage = page;
    }
  },
  mounted() {
    this.currentPage = Number(this.$route.query.page) || 1;
    this.getProducts();
    this.firstPage = 1;
  },
  methods: {
    withVat(consumer_price) {
      return (((Number(consumer_price) / 100) * Number(this.setting.vat_percentage.replace('%', ''))) + Number(consumer_price)).toFixed(2);
    },
    getProducts() {
      this.noSearchResult = false;
      products(this, this.currentPage, this.search, (response) => {
        this.products = response.products.data;
        this.setting = response.setting;
        this.lastPage = Number(response.products.last_page);
        this.perPage = Number(response.products.per_page);
        this.total = Number(response.products.total);
        this.from = Number(response.products.from);
        this.to = Number(response.products.to);
        this.loaded = true;
        if (this._.isEmpty(this.products)) {
          if (!this._.isEmpty(this.search)) {
            this.noSearchResult = true;
          } else {
            this.message = this.$t('empty_list');
          }
        }
        this.$forceUpdate();
      });
    },
    clearSearch() {
      if (this.search !== '') {
        this.search = '';
        this.getProducts();
      }
    },
    runSearch: _.debounce(function() {
      this.currentPage = 1;
      this.getProducts();
    }, 500),
    editProduct(productIndex) {
      this.$router.push({ name: 'Product', params: {product_id: this.products[productIndex]['id'] } });
    },
    deleteProduct(productIndex) {
      this.$store.commit('confirmation', {
        message: this.$t('are_you_sure_that_you_want_to_delete_this_product', { productName: this.products[productIndex].name }),
        onOk: () => {
          this.error = '';
          this.message = '';
          deleteProduct(this, this.products[productIndex]['id'], (response) => {
            this.$delete(this.products, productIndex);
            this.total -= 1;
            this.message = response.message;
            if (this.total > this.products.length && this.products.length > 0 && this.currentPage !== this.lastPage) {
              this.getProducts();
            } else if (this.products.length === 0 && this.currentPage > 1) {
              this.currentPage -= 1;
            }
            this.$forceUpdate();
          }, (error) => {
            this.error = error.message;
          });
        }
      })
    },
    toggleBlock(productIndex) {
      if (this.products[productIndex]['blocked']) {
        unBlockProduct(this, this.products[productIndex]['id'], () => {
          this.products[productIndex]['blocked'] = false;
        }, (error) => {
          this.error = error.message;
        });
      } else {
        blockProduct(this, this.products[productIndex]['id'], () => {
          this.products[productIndex]['blocked'] = true;
        }, (error) => {
          this.error = error.message;
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wy-list-page {
  .wy-search-input-container::v-deep {
    position: relative;
    input {
      background-color: #F1F1F1;
      [dir=ltr] & {
        padding-right: 40px;
      }

      [dir=rtl] & {
        padding-left: 40px;
      }
    }
    button.wy-clear-button {
      position: absolute;
      background: none;
      border: none;
      top: 8px;
      color: #C41117;
      transition: color 350ms ease;
      [dir=ltr] & {
        right: 5px;
      }

      [dir=rtl] & {
        left: 5px;
      }
      span {
        margin: 0!important;
        font-size: 24px;
      }
      &:focus {
        outline: none;
      }
      &:hover {
        color: #222222;
      }
    }
  }
  .wy-list-table {
    thead {
      th {
        border-top-width: 0;
      }
    }
  }
}
</style>
